import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useImperativeHandle,
} from 'react';
import {
  Autocomplete,
  TextField,
} from '@mui/material';
import { FileText } from 'lucide-react';
import {
  DataTable,
  Badge,
  SpinnerLoader,
  Button,
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
  Label,
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
  DatePicker as LiftDatePicker,
} from 'lift-ui';
import type { TableColumn } from 'lift-ui';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Toastify } from 'lift-ui';
import { debounce } from '@lift-admin/utils/debounce';
import { useThrottledFn } from '@lift-admin/utils/throttle';
import dayjs from 'dayjs';
import moment from 'moment';
import isEmail from 'validator/lib/isEmail';
import apiClient from '@lift-admin/utils/apiClient';
import { actionLog } from '../../../../App';

/** Single source of truth for backfill sheet dates — avoids drift vs close-handler reset. */
function getDefaultAffluentTriggerState() {
  return {
    checked: false,
    import_start: dayjs().subtract(90, 'day').startOf('day'),
    import_end: dayjs().startOf('day'),
    email: '',
    import_type: 1,
    brand_selected: '',
  };
}

const AffluentImports = ({ childRef, hasEditAccess = true, canTriggerImport = false, onCountChange }: any) => {
  const [affluent, setAffluent] = useState<any[]>([]);
  const [affluentBackup, setAffluentBackup] = useState<any>([]);
  const [page, setPage] = useState<any>(0);
  const [pageLog, setPageLog] = useState<any>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(25);
  const [rowsPerPageLog, setRowsPerPageLog] = useState<any>(25);
  const [showTriggerBackFill, setShowTriggerBackFill] = useState<any>(false);
  const [brandsData, setBrandsData] = useState<any>([]);
  const user = JSON.parse(localStorage.getItem('user') as string);
  const [totalCount, setTotalCount] = useState<number>();
  const [loadingData, setLoadingData] = useState<boolean>(false);
  // const [trigger, setTrigger] = useState({
  //   checked: false,
  //   import_start: dayjs(new Date(new Date() - 60 * 24 * 60 * 60 * 1000)),
  //   email: '',
  //   import_type: 1,
  // });
  const [trigger, setTrigger] = useState<any>(() => getDefaultAffluentTriggerState());

  const [hideTriggerProgressDialog, setHideTriggerProgressDialog] =
    useState(true);

  //super token

  const handleChangePageLog = (_: any, newPage: any) => {
    setPageLog(newPage);
  };

  const handleChangeRowsPerPageLog = (event: any) => {
    setRowsPerPageLog(+event.target.value);
    setPageLog(0);
  };

  const get_ref = useRef<any>(true);
  useEffect(() => {
    if (get_ref.current) {
      get_ref.current = false;
      getAffluentData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // getting ll brand weights
  const [listLoad, setListLoad] = useState(true);
  const getAffluentData = async () => {
    try {
      setLoadingData(true);
      const res = await apiClient.get(
        `/import/v1/affluent/affluent/history?cursor=&limit=10000&dir=undefined`
      );
      
      setListLoad(false);
      const data = res.data.response.data.sort(customSort);
      const apiTotalCount = res?.data?.response?.totalCount ?? data.length;
      setAffluent(data);
      setAffluentBackup(data);
      setTotalCount(apiTotalCount);
      onCountChange?.(apiTotalCount, apiTotalCount);
    } catch (err: any) {
      Toastify('error', err.response.data.message);
    } finally {
      setLoadingData(false);
    }
  };

  const throttleGetBrandWeights = useThrottledFn(getAffluentData, 1000);

  const customSort = (a: any, b: any) =>
    (new Date(b.id) as any) - (new Date(a.id) as any);

  // Search results
  const searchResults = (query: any) => {
    let results: any[] = [];
    for (let i = 0; i < affluentBackup.length; i++) {
      if (
        affluentBackup[i]['brand'].toLowerCase().includes(query.toLowerCase())
      )
        results.push(affluentBackup[i]);
    }

    setAffluent(results);
    onCountChange?.(results.length, totalCount ?? affluentBackup.length);
  };

  const searchOptimized = useCallback(debounce(searchResults, 600), [
    affluentBackup,
    totalCount,
    onCountChange,
  ]);
  const [showlogs, setShowLogs] = useState<any>(null);

  const explandRow = (idx: any) => {
    if (showlogs === idx) {
      setShowLogs(null);
      return;
    }
    setShowLogs(idx);
  };
  const [logsDetails, setLogsDetails] = useState([]);
  const [logsDetailsBackup, setLogsDetailsBackUp] = useState([]);

  const getLogs = async (id: any) => {
    try {
      const res = await apiClient.get(
        `/import/v1/affluent/affluent/logs/${id}`
      );
      console.log(res.data.response, 'res');
      const sorted = res.data.response.sort(customSort);
      setLogsDetails(sorted);
      setLogsDetailsBackUp(sorted);
    } catch (error: any) {
      Toastify('error', error.response.data.message);
      console.log(error);
    }
  };

  const TriggerBackFull = async () => {
    try {
      // if (affluentBackup[0].status === 1) {
      //   Toastify('error', 'One Trigger is still in process !!');
      //   return;
      // }
      if (trigger.checked) {
        if (!isEmail(trigger.email)) {
          Toastify('error', 'Not a valid email !!');
          return;
        }
      }

      const checkData = {
        notify: trigger.checked ? 1 : 0,
        email: trigger.email.length === 0 ? '' : trigger.email,
        import_start: moment(new Date(trigger.import_start)).format(
          'YYYY-MM-DD'
        ),
      };

      setHideTriggerProgressDialog(false);

      // admin/trigger/affluent/actuals

      if (trigger.import_type === 1) {
        const res = await apiClient.post(
          `/affluent-import/affluent/trigger`,
          {
            start_date: moment(new Date(trigger.import_start)).format(
              'YYYY-MM-DD'
            ),
            end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
            description: "Affluent Import"
          }
        );
        const importMsg = {
          start_date: moment(new Date(trigger.import_start)).format(
            'YYYY-MM-DD'
          ),
          end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
          description: "Affluent Import"
        };


        const desc = {
          message: `Triggered affluent import`,
          status: res.status,
          method: res.config.method,
          url: res.config.url,
          category: 'import',
          importType: 'affluent',
        };

        await actionLog?.actionLogTrack(JSON.stringify(desc), false);
        console.log(importMsg, 'importMsgf');
      } else if (trigger.import_type === 2) {
        const res = await apiClient.post(
          `/affluent-import/daily-actuals/trigger`,
          {
            start_date: moment(new Date(trigger.import_start)).format(
              'YYYY-MM-DD'
            ),
            end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
            description: "Daily Actuals Import"
          }
        );

        console.log(res, 'actuals');

        const importMsg = {
          start_date: moment(new Date(trigger.import_start)).format(
            'YYYY-MM-DD'
          ),
          end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
          description: "Daily Actuals Import"
        };
        const desc = {
          message: `Trigger import ${JSON.stringify(importMsg)} type 2`,
          status: res.status,
          method: res.config.method,
          url: res.config.url,
        };

        await actionLog?.actionLogTrack(JSON.stringify(desc), false);
      } else if (trigger.import_type === 3) {
        const res = await apiClient.post(
          `/affluent-import/merged-publisher/trigger`,
          {
            start_date: moment(new Date(trigger.import_start)).format(
              'YYYY-MM-DD'
            ),
            end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
            description: "Merged Publishers Import"
          }
        );

        console.log(res, 'merged');

        const importMsg = {
          start_date: moment(new Date(trigger.import_start)).format(
            'YYYY-MM-DD'
          ),
          end_date: moment(new Date(trigger.import_end)).format(
            'YYYY-MM-DD'
          ),
          description: "Merged Publishers Import"
        };
        const desc = {
          message: `Trigger import ${JSON.stringify(importMsg)} type 3`,
          status: res.status,
          method: res.config.method,
          url: res.config.url,
        };

        await actionLog?.actionLogTrack(JSON.stringify(desc), false);
      } else if (trigger.import_type === 4) {
        const res = await apiClient.post(
          `/affluent-import/content-analysis/trigger`,
          {
            start_date: moment(new Date(trigger.import_start)).format(
              'YYYY-MM-DD'
            ),
            end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
            description: "Content Analysis Import"
          }
        );

        const importMsg = {
          start_date: moment(new Date(trigger.import_start)).format(
            'YYYY-MM-DD'
          ),
          end_date: moment(new Date(trigger.import_end)).format(
            'YYYY-MM-DD'
          ),
          description: "Content Analysis Import"
        };
        const desc = {
          message: `Trigger import ${JSON.stringify(importMsg)} type 4`,
          status: res.status,
          method: res.config.method,
          url: res.config.url,
        };

        await actionLog?.actionLogTrack(JSON.stringify(desc), false);
      } else if (trigger.import_type === 5) {
        const res = await apiClient.post(
          `/import/v1/import/trigger/affluent/all`,
          {
            notify: trigger.checked ? 1 : 0,
            email: trigger.email.length === 0 ? '' : trigger.email,
            import_start: moment(new Date(trigger.import_start)).format(
              'YYYY-MM-DD'
            ),
            import_end: moment(new Date(trigger.import_end)).format(
              'YYYY-MM-DD'
            ),
          }
        );

        const importMsg = {
          notify: trigger.checked ? 1 : 0,
          email: trigger.email.length === 0 ? '' : trigger.email,
          import_start: moment(new Date(trigger.import_start)).format(
            'YYYY-MM-DD'
          ),
          import_end: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
        };
        const desc = {
          message: `Trigger import ${JSON.stringify(importMsg)} type 4`,
          status: res.status,
          method: res.config.method,
          url: res.config.url,
        };

        await actionLog?.actionLogTrack(JSON.stringify(desc), false);
      } else if (trigger.import_type === 6) {
        const res = await apiClient.post(
          `/affluent-import/affluent/trigger`,
          {
            start_date: moment(new Date(trigger.import_start)).format(
              'YYYY-MM-DD'
            ),
            end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
            description: "Affluent Import for One Brand",
            brand_name: trigger.brand_selected
          }
        );

        const importMsg = {
          start_date: moment(new Date(trigger.import_start)).format(
            'YYYY-MM-DD'
          ),
          end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
          description: "Affluent Import for One Brand",
          brand_name: trigger.brand_selected
        };
        const desc = {
          message: `Trigger import ${JSON.stringify(importMsg)} type 1`,
          status: res.status,
          method: res.config.method,
          url: res.config.url,
        };

        await actionLog?.actionLogTrack(JSON.stringify(desc), false);
        console.log(importMsg, 'importMsgf');
      } else if (trigger.import_type === 7) {
        const res = await apiClient.post(
          `/affluent-import/promocode/trigger`,
          {
            start_date: moment(new Date(trigger.import_start)).format('YYYY-MM-DD'),
            end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
            description: "Promocode Import",
          }
        );

        const importMsg = {
          start_date: moment(new Date(trigger.import_start)).format('YYYY-MM-DD'),
          end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
          description: "Promocode Import",
        };
        const desc = {
          message: `Trigger import ${JSON.stringify(importMsg)} type 6 (Promocode)`,
          status: res.status,
          method: res.config.method,
          url: res.config.url,
        };

        await actionLog?.actionLogTrack(JSON.stringify(desc), false);
      } else if (trigger.import_type === 8) {
        const res = await apiClient.post(
          `/affluent-import/sku/trigger`,
          {
            start_date: moment(new Date(trigger.import_start)).format('YYYY-MM-DD'),
            end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
            description: "SKU Import",
          }
        );

        const importMsg = {
          start_date: moment(new Date(trigger.import_start)).format('YYYY-MM-DD'),
          end_date: moment(new Date(trigger.import_end)).format('YYYY-MM-DD'),
          description: "SKU Import",
        };
        const desc = {
          message: `Trigger import ${JSON.stringify(importMsg)} type 7 (SKU)`,
          status: res.status,
          method: res.config.method,
          url: res.config.url,
        };

        await actionLog?.actionLogTrack(JSON.stringify(desc), false);
      } else {
        throw new Error(
          'Trigger import type is not correct. Make sure to select correct import type!!'
        );
      }

      getAffluentData();
      Toastify(
        'success',
        trigger.import_type === 1
          ? 'Affluent import triggered successfully !!'
          : trigger.import_type === 2
            ? 'Daily actuals import triggered successfully !!'
            : trigger.import_type === 3
              ? 'Merge publishers import triggered successfully !!'
              : trigger.import_type === 4
                ? 'Content analysis import triggered successfully !!'
                : trigger.import_type === 5
                  ? 'Merge publishers import triggered successfully !!'
                  : trigger.import_type === 6
                    ? 'Affluent import for one brand triggered successfully !!'
                    : trigger.import_type === 7
                      ? 'Promocode import triggered successfully !!'
                      : 'SKU import triggered successfully !!'
      );
      setHideTriggerProgressDialog(true);
      setShowTriggerBackFill(false);
      setTrigger({
        checked: false,
        import_start: dayjs().startOf('day'),
        import_end: dayjs().startOf('day'),
        email: '',
        brand_selected: '',
        import_type: 1,
      });
    } catch (error: any) {
      // console.log(error, 'error trigger');
      Toastify('error', 'Error Trigger');
      setHideTriggerProgressDialog(true);
      setShowTriggerBackFill(false);
      if (error.response) {
        Toastify('error', error.response.data.message);
      } else {
        Toastify('error', 'Somthing went wrong !!');
      }

      await actionLog?.actionLogTrack(JSON.stringify(error), true);
    }
  };

  const stopAffluentTrigger = async (id: any) => {
    try {
      await apiClient.post(`/import/jobs/${id}/stop`);
      Toastify('success', 'Trigger stopped successfully !!');
      getAffluentData();
    } catch (error: any) {
      Toastify('error', 'Error stopping trigger');
      if (error.response) {
        Toastify('error', error.response.data.message);
      } else {
        Toastify('error', 'Something went wrong !!');
      }
      await actionLog?.actionLogTrack(JSON.stringify(error), true);
    }
  };

  const formatDate = (timeStamp: any) => {
    if (timeStamp) {
      let date = new Date(timeStamp);
      return (
        date.getMonth() +
        1 +
        '/' +
        date.getDate() +
        '/' +
        date.getFullYear() +
        ' ' +
        date.getHours() +
        ':' +
        date.getMinutes() +
        ':' +
        date.getSeconds()
      );
    } else {
      return 'N/A';
    }
  };
  //setShowTriggerBackFill(true)

  useImperativeHandle(childRef, () => ({
    addAffluentTrigger() {
      setTrigger(getDefaultAffluentTriggerState());
      setShowTriggerBackFill(true);
    },
    searchResultTrigger(query: any) {
      searchResults(query);
    },
    getAffluentData,
  }));

  const [logType, setLogType] = useState(0);

  const Filter = (type: any) => {
    console.log(type, 'type');
    if (type !== 0) {
      const res = logsDetailsBackup.filter((d: any) => d.type === type);
      setLogsDetails(res);
    } else {
      setLogsDetails([...logsDetailsBackup]);
    }
    setLogType(type);
  };

  const getLogTypeBadge = (type: number) => {
    if (type === 1) {
      return <Badge variant="outline" className="bg-green-100 text-green-800 border-green-300">Trigger</Badge>;
    } else if (type === 2) {
      return <Badge variant="outline" className="bg-yellow-100 text-yellow-800 border-yellow-300">Log</Badge>;
    } else {
      return <Badge variant="destructive" className="bg-red-100 text-red-800 border-red-300">Error</Badge>;
    }
  };

  const defaultSetForTrigger = () => {
    setShowTriggerBackFill(false);
    setTrigger(getDefaultAffluentTriggerState());
  };

  const importType = (type: any) => {
    if (type === 1) {
      return 'Affluent Import';
    } else if (type === 2) {
      return 'Daily Actual Imports';
    } else if (type === 3) {
      return 'Merged Publisher Imports';
    } else if (type === 4) {
      return 'Content Analysis Import';
    } else if (type === 5) {
      return 'Merged Publisher Imports';
    } else if (type === 6) {
      return 'Promocode Import';
    } else if (type === 7) {
      return 'SKU Import';
    }
    return '';
  };

  const getStatusBadge = (status: number) => {
    if (status === 2) {
      return <Badge variant="outline" className="bg-green-100 text-green-800 border-green-300">Completed</Badge>;
    } else if (status === 3) {
      return <Badge variant="destructive" className="bg-red-100 text-red-800 border-red-300">Failed</Badge>;
    } else {
      return <Badge variant="outline" className="bg-yellow-100 text-yellow-800 border-yellow-300">Processing</Badge>;
    }
  };

  const handleStartDateChange = (newValue: Date | undefined) => {
    if (!newValue) return;
    const newStart = dayjs(newValue);
    const maxEndDate = newStart.add(6, 'month');
    if (maxEndDate.isBefore(trigger.import_end, 'day')) {
      setTrigger({
        ...trigger,
        import_start: newStart,
        import_end: maxEndDate,
      });
    } else {
      setTrigger({
        ...trigger,
        import_start: newStart,
      });
    }
  };

  const handleEndDateChange = (newValue: Date | undefined) => {
    if (!newValue) return;
    if (dayjs(newValue).isAfter(dayjs(), 'day')) {
      Toastify('error', 'Date must be before today');
      return;
    }
    setTrigger({
      ...trigger,
      import_end: dayjs(newValue),
    });
  };

  useEffect(() => {
    console.log(trigger.brand_selected);

    try {
      apiClient
        .get(`/brand/v1/admin/brands/all`)
        .then((res) => setBrandsData(res.data.response))
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  }, [trigger]);

  const paginatedData = useMemo(() => {
    const start = page * rowsPerPage;
    return affluent.slice(start, start + rowsPerPage);
  }, [affluent, page, rowsPerPage]);

  const dataTableColumns = useMemo((): TableColumn<any>[] => [
    {
      key: 'created_at',
      header: 'Started At',
      accessor: (row: any) => row.created_at,
      render: (_v: any, row: any) => formatDate(row.created_at),
    },
    {
      key: 'completed_at',
      header: 'Completed At',
      accessor: (row: any) => row.completed_at,
      render: (_v: any, row: any) =>
        row.completed_at && row.completed_at.length !== 0 ? formatDate(row.completed_at) : '--',
    },
    {
      key: 'status',
      header: 'Status',
      accessor: 'status',
      render: (_v: any, row: any) => getStatusBadge(row.status),
    },
    {
      key: 'import_start_date',
      header: 'Import Start',
      accessor: (row: any) => row.import_start_date,
      render: (_v: any, row: any) => moment(row.import_start_date).format('MM/DD/YY'),
    },
    {
      key: 'notify',
      header: 'Notify',
      accessor: (row: any) => row.notify,
      render: (_v: any, row: any) => (row.notify === 1 ? row.email : 'Not Set'),
    },
    {
      key: 'type',
      header: 'Type',
      accessor: (row: any) => row.type,
      render: (_v: any, row: any) => importType(row.type),
    },
    {
      key: 'show_logs',
      header: 'Show Logs',
      accessor: (row: any) => row.id,
      width: '100px',
      align: 'center' as const,
      render: (_v: any, row: any) => {
        const indexInPage = paginatedData.findIndex((r: any) => (r.id || r) === (row.id || row));
        if (indexInPage < 0) return null;
        return (
          <FileText
            onClick={() => {
              explandRow(indexInPage);
              getLogs(row.id);
            }}
            className="h-5 w-5 cursor-pointer inline-block hover:opacity-80"
          />
        );
      },
    },
  ], [paginatedData]);

  const logsPaginatedData = useMemo(() => {
    const start = pageLog * rowsPerPageLog;
    return logsDetails.slice(start, start + rowsPerPageLog);
  }, [logsDetails, pageLog, rowsPerPageLog]);

  const logsTableColumns = useMemo((): TableColumn<any>[] => [
    {
      key: 'created_at',
      header: 'Created At',
      accessor: (row: any) => row.created_at,
      render: (_v: any, row: any) => moment(row.created_at).format('MM/DD/YYYY'),
    },
    {
      key: 'type',
      header: 'Type',
      accessor: 'type',
      render: (_v: any, row: any) => (
        <div className="flex justify-center">
          {getLogTypeBadge(row.type)}
        </div>
      ),
    },
    {
      key: 'message',
      header: 'Message',
      accessor: 'message',
      render: (_v: any, row: any) => <div className="actions-div">{row.message}</div>,
    },
  ], []);

  const logsEmptyMessage =
    logType === 0
      ? 'No Message'
      : logType === 2
        ? 'No Message Logs'
        : logType === 1
          ? 'No Message Trigger'
          : 'No Message Error';

  const logsDataTable = (
    <div className="flex-1 flex flex-col min-h-0 pr-2">
      <DataTable
        className="flex-1 min-h-0 overflow-auto"
        maxHeight="100%"
        columns={logsTableColumns}
        data={logsPaginatedData}
        loading={listLoad}
        emptyMessage={logsEmptyMessage}
        stickyHeader
        stickyFooter
        showActions={false}
        pagination={{
          currentPage: pageLog + 1,
          totalPages: Math.max(1, Math.ceil(logsDetails.length / rowsPerPageLog)),
          pageSize: rowsPerPageLog,
          totalItems: logsDetails.length,
          onPageChange: (p) => setPageLog(Math.max(0, p - 1)),
          onPageSizeChange: (size) => { setRowsPerPageLog(size); setPageLog(0); },
          pageSizeOptions: [25, 50, 100, 200],
        }}
      />
    </div>
  );

  return (
    <div className="flex flex-col h-full">
      {/* Trigger Backfill Sheet */}
      <Sheet open={showTriggerBackFill} onOpenChange={(open) => !open && defaultSetForTrigger()}>
        <SheetContent side="right" className="w-[500px] sm:max-w-[500px] flex flex-col h-full">
          <SheetHeader>
            <SheetTitle>Trigger Backfill</SheetTitle>
          </SheetHeader>

          <div className="flex-1 overflow-y-auto py-4">
            <div className="space-y-4">
              {/* Date Pickers */}
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Start Date</Label>
                  <LiftDatePicker
                    value={trigger.import_start ? dayjs(trigger.import_start).toDate() : undefined}
                    onChange={handleStartDateChange}
                    className="w-full"
                  />
                </div>
                <div className="space-y-2">
                  <Label>End Date</Label>
                  <LiftDatePicker
                    value={trigger.import_end ? dayjs(trigger.import_end).toDate() : undefined}
                    onChange={handleEndDateChange}
                    className="w-full"
                  />
                </div>
              </div>

              {/* Import Type Select */}
              <div className="space-y-2">
                <Label>Import Type</Label>
                <Select
                  value={String(trigger.import_type)}
                  onValueChange={(value) => setTrigger({ ...trigger, import_type: Number(value) })}
                >
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select import type" />
                  </SelectTrigger>
                  <SelectContent className="w-[var(--radix-select-trigger-width)] min-w-[300px]">
                    <SelectItem value="1">Affluent Import</SelectItem>
                    <SelectItem value="2">Daily Actuals Import</SelectItem>
                    <SelectItem value="3">Merged Publisher Import</SelectItem>
                    <SelectItem value="4">Content Analysis Import</SelectItem>
                    <SelectItem value="6">Affluent Import for One Brand</SelectItem>
                    <SelectItem value="7">Promocode Import</SelectItem>
                    <SelectItem value="8">SKU Import</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Brand Selection (for type 6) */}
              {trigger.import_type === 6 && (
                <div className="space-y-2">
                  <Label>Select Brand</Label>
                  <Autocomplete
                    id="brand-select"
                    options={brandsData}
                    getOptionLabel={(option: any) => option.name}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        placeholder="Search brand..."
                        size="small"
                        fullWidth
                      />
                    )}
                    onChange={(e: any, value: any) => {
                      setTrigger({
                        ...trigger,
                        brand_selected: value ? value.name : '',
                      });
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          <SheetFooter className="border-t pt-4">
            <Button variant="outline" onClick={() => defaultSetForTrigger()}>
              Cancel
            </Button>
            {canTriggerImport && (
              <Button
                onClick={() => {
                  if (hideTriggerProgressDialog) {
                    TriggerBackFull();
                  }
                }}
                disabled={!hideTriggerProgressDialog}
              >
                {!hideTriggerProgressDialog ? (
                  <SpinnerLoader className="h-4 w-4 mr-2" />
                ) : null}
                Trigger
              </Button>
            )}
          </SheetFooter>
        </SheetContent>
      </Sheet>
      <Sheet
        open={showlogs !== null}
        onOpenChange={(open) => {
          if (!open) {
            setShowLogs(null);
            setLogsDetails([]);
            setLogType(0);
          }
        }}
      >
        <SheetContent
          side="right"
          className="w-[800px] sm:max-w-[800px] flex flex-col h-full overflow-y-auto"
        >
          <SheetHeader>
            <SheetTitle>Logs</SheetTitle>
          </SheetHeader>

          <Tabs
            value={String(logType)}
            onValueChange={(v) => Filter(Number(v))}
            className="flex flex-1 flex-col min-h-0 mt-4"
          >
            <TabsList className="grid grid-cols-4 w-fit mb-4">
              <TabsTrigger value="0">All</TabsTrigger>
              <TabsTrigger value="2">Logs</TabsTrigger>
              <TabsTrigger value="1">Trigger</TabsTrigger>
              <TabsTrigger value="3">Error</TabsTrigger>
            </TabsList>
            <TabsContent value="0" className="flex-1 flex flex-col min-h-0 mt-0 data-[state=inactive]:hidden">
              {logsDataTable}
            </TabsContent>
            <TabsContent value="1" className="flex-1 flex flex-col min-h-0 mt-0 data-[state=inactive]:hidden">
              {logsDataTable}
            </TabsContent>
            <TabsContent value="2" className="flex-1 flex flex-col min-h-0 mt-0 data-[state=inactive]:hidden">
              {logsDataTable}
            </TabsContent>
            <TabsContent value="3" className="flex-1 flex flex-col min-h-0 mt-0 data-[state=inactive]:hidden">
              {logsDataTable}
            </TabsContent>
          </Tabs>

          <SheetFooter className="border-t pt-4 mt-4 flex-shrink-0">
            <Button
              variant="outline"
              onClick={() => {
                setShowLogs(null);
                setLogsDetails([]);
                setLogType(0);
              }}
            >
              Close
            </Button>
          </SheetFooter>
        </SheetContent>
      </Sheet>

      {/* Table */}
      <div className="flex-1 flex flex-col min-h-0">
        <DataTable
          className="flex-1 min-h-0 overflow-auto"
          maxHeight="calc(100vh - 170px)"
          columns={dataTableColumns}
          data={paginatedData}
          loading={listLoad}
          emptyMessage="No imports found."
          stickyHeader
          stickyFooter
          showActions={false}
          pagination={{
            currentPage: page + 1,
            totalPages: Math.max(1, Math.ceil(affluent.length / rowsPerPage)),
            pageSize: rowsPerPage,
            totalItems: affluent.length,
            onPageChange: (p) => setPage(Math.max(0, p - 1)),
            onPageSizeChange: (size) => { setRowsPerPage(size); setPage(0); },
            pageSizeOptions: [25, 50, 100, 200, 500],
          }}
        />
      </div>
    </div>
  );
};

export default AffluentImports;
